// Static fallback list of services so the app still works without the backend.
export const fallbackServices = [
  {
    id: "aroma-oil",
    title: "Aroma Öl Massage",
    price: "27,00 €",
    originalPrice: "47,00 €",
    duration: "30 min",
    description:
      "Eine entspannende Massage mit ätherischen Ölen zur Entspannung von Körper und Geist.",
  },
  {
    id: "abhyanga",
    title: "Abhyanga / Ayurveda Ganzkörpermassage",
    price: "56,00 €",
    originalPrice: "76,00 €",
    duration: "60 min",
    description:
      "Traditionelle ayurvedische Ganzkörpermassage für tiefe Entspannung und Entgiftung.",
  },
  {
    id: "hot-stone",
    title: "Hot Stone Massage",
    price: "45,00 €",
    originalPrice: "65,00 €",
    duration: "45 min",
    description:
      "Therapeutische Massage mit erwärmten Steinen, die Muskelverspannungen löst.",
  },
  {
    id: "full-body",
    title: "Ganzkörpermassage",
    price: "83,00 €",
    originalPrice: "103,00 €",
    duration: "90 min",
    description:
      "Komplette Ganzkörpermassage, individuell auf Ihre Bedürfnisse abgestimmt.",
  },
  {
    id: "thai",
    title: "Thai Massage",
    price: "55,00 €",
    originalPrice: "75,00 €",
    duration: "60 min",
    description:
      "Uraltes Heilsystem, das Akupressur, ayurvedische Prinzipien und unterstützte Yoga-Positionen kombiniert.",
  },
  {
    id: "sanjeevani",
    title: "Sanjeevani Massage",
    price: "39,00 €",
    originalPrice: "59,00 €",
    duration: "45 min",
    description:
      "Revitalisierende Massage zur Wiederherstellung von Energie und Vitalität.",
  },
  {
    id: "leg-foot",
    title: "Bein und Fuß Massage (mit Peeling)",
    price: "39,00 €",
    originalPrice: "59,00 €",
    duration: "45 min",
    description:
      "Bein- und Fußmassage mit Peeling-Behandlung für vollständige Entspannung und Regeneration.",
  },
  {
    id: "mukabhyanga",
    title: "Mukabhyanga Massage",
    price: "38,00 €",
    originalPrice: "58,00 €",
    duration: "45 min",
    description:
      "Ayurvedische Gesichtsmassage für tiefe Entspannung und Hautverjüngung.",
  },
  {
    id: "back",
    title: "Rückenmassage",
    price: "38,00 €",
    originalPrice: "58,00 €",
    duration: "45 min",
    description:
      "Gezielte Rückenmassage zur Linderung von Verspannungen und Muskelschmerzen.",
  },
];



